import React, { useEffect, useState } from 'react';
import { motion, useScroll, useSpring, useTransform, AnimatePresence } from 'framer-motion';

// IMPORTY ZASOBÓW
import logoKlubu from './indian.png';
import zdj1 from './zdj1.jpg';

// --- TRANSLACJE ---
const translations = {
    pl: {
        nav: ['START', 'O KLUBIE', 'HISTORIA'],
        heroSub: 'Pierwszy Oficjalny Klub IMRG w Europie',
        heroTitle: ['TRADYCJA', 'WOLNOŚĆ'],
        aboutTitle: ['FIRST', 'INDIAN POLAND'],
        aboutText: 'Nasz klub powstał z pasji do marki Indian oraz idei budowania silnej społeczności riderów w Polsce. Jesteśmy dumni, że stanowimy First Indian Poland Group, będąc jednocześnie pierwszym klubem tej marki w Europie.',
        aboutBtn: 'GALERIA ZDJĘĆ',
        historyTitle: ['NASZA', 'DROGA'],
        historyItems: [
            { y: "2015", t: "POCZĄTEK", d: "Inicjatywa Piotra Dobrowolskiego w Lublinie. Powstaje pierwszy klub Indian w Europie i grupa First Indian Poland." },
            { y: "2016", t: "HISTORIA", d: "Oficjalne przystąpienie do Indian Motorcycle Riders Group (IMRG), otwierające drzwi do międzynarodowej społeczności." },
            { y: "2026", t: "BRATERSTWO", d: "Obecnie 15 członków tworzy naszą rodzinę, połączoną wspólnymi wartościami i miłością do przygód na dwóch kołach." }
        ],
        location: 'SIEDZIBA I CENTRUM SPOTKAŃ: LUBLIN',
        createdBy: 'UTWORZONE PRZEZ',
        loadMore: 'ZAŁADUJ WIĘCEJ',
        showLess: 'ZWIŃ GALERIĘ'
    },
    en: {
        nav: ['START', 'ABOUT US', 'HISTORY'],
        heroSub: 'First Official IMRG Club in Central Europe',
        heroTitle: ['TRADITION', 'FREEDOM'],
        aboutTitle: ['FIRST', 'INDIAN POLAND'],
        aboutText: 'Our club was born from passion for the Indian brand and the idea of building a strong community of riders in Poland. We are proud to be the First Indian Poland Group, being the first Indian club in Europe.',
        aboutBtn: 'PHOTO GALLERY',
        historyTitle: ['OUR', 'JOURNEY'],
        historyItems: [
            { y: "2015", t: "BEGINNING", d: "Initiative of Piotr Dobrowolski in Lublin. The first Indian club in Europe and the First Indian Poland group are established." },
            { y: "2016", t: "HISTORY", d: "Official affiliation with the Indian Motorcycle Riders Group (IMRG), joining the international community." },
            { y: "2026", t: "BROTHERHOOD", d: "Currently 15 members form our family, united by shared values and a passion for two-wheeled adventures." }
        ],
        location: 'HEADQUARTERS & MEETING CENTER: LUBLIN',
        createdBy: 'CREATED BY',
        loadMore: 'LOAD MORE',
        showLess: 'SHOW LESS'
    }
};

// --- GLOBALNE STYLE CSS ---
const globalStyles = `
    @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;700;900&family=Oswald:wght@200;400;700&display=swap');
    
    :root {
        --burgund: #5E0000;
        --champagne: #E5C48B;
        --bg-dark: #000000;
        --bg-light: #030303;
    }

    html { scroll-behavior: smooth; background: var(--bg-dark); }
    body { margin: 0; background-color: var(--bg-dark); color: var(--champagne); font-family: 'Oswald', sans-serif; overflow-x: hidden; }
    
    ::-webkit-scrollbar { width: 6px; }
    ::-webkit-scrollbar-track { background: var(--bg-dark); }
    ::-webkit-scrollbar-thumb { background: var(--burgund); }
    
    .glass-card { background: rgba(7, 7, 7, 0.85); backdrop-filter: blur(12px); border: 1px solid rgba(229, 196, 139, 0.15); transition: all 0.3s ease; }
    .glass-card:hover { border-color: var(--burgund); transform: translateY(-5px); }
    
    .lang-btn { cursor: pointer; background: none; border: 1px solid rgba(229, 196, 139, 0.3); color: var(--champagne); padding: 4px 8px; font-family: 'Oswald'; font-size: 10px; letter-spacing: 2px; transition: 0.3s; }
    .lang-btn.active { background: var(--burgund); border-color: var(--burgund); }
    
    .main-btn { background: none; border: 1px solid var(--champagne); color: var(--champagne); padding: 12px 30px; font-family: 'Oswald'; font-size: 12px; letter-spacing: 4px; cursor: pointer; transition: 0.4s; text-decoration: none; display: inline-block; margin-top: 40px; }
    .main-btn:hover { background: var(--burgund); border-color: var(--burgund); color: #fff; box-shadow: 0 0 20px rgba(94, 0, 0, 0.4); }

    .creator-link { color: var(--champagne); text-decoration: none; transition: color 0.3s ease; font-weight: 700; }
    .creator-link:hover { color: var(--burgund); }

    .desktop-nav { display: flex; gap: 40px; font-size: 11px; letter-spacing: 4px; color: var(--champagne); font-weight: 700; }
    .mobile-hamburger { display: none; flex-direction: column; gap: 5px; cursor: pointer; padding: 5px; }
    .mobile-hamburger div { width: 25px; height: 2px; background: var(--champagne); transition: 0.3s; }

    /* Lightbox Styles */
    .lightbox-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.95); z-index: 4000; display: flex; justify-content: center; align-items: center; padding: 20px; }
    .lightbox-img { max-width: 100%; max-height: 90vh; border: 2px solid var(--burgund); box-shadow: 0 0 30px rgba(94, 0, 0, 0.5); object-fit: contain; }
    .close-btn { position: absolute; top: 20px; right: 30px; background: none; border: none; color: var(--champagne); font-size: 2rem; cursor: pointer; font-family: 'Oswald'; transition: 0.3s; z-index: 4001; }
    .close-btn:hover { color: var(--burgund); transform: scale(1.1); }

    @media (max-width: 768px) {
        .desktop-nav { display: none !important; }
        .mobile-hamburger { display: flex !important; }
        
        .nav-container { padding: 15px 20px !important; }
        .hero-title { font-size: 2.2rem !important; letter-spacing: 8px !important; }
        .hero-sub { font-size: 10px !important; letter-spacing: 4px !important; }
        .section-padding { padding: 60px 20px !important; }
        
        .about-grid { grid-template-columns: 1fr !important; gap: 40px !important; text-align: center; }
        .history-grid { grid-template-columns: 1fr !important; }
    }
`;

// SYMULACJA 50 PUSTYCH MIEJSC NA ZDJĘCIA Z BAZY / IMPORTU
// Używamy placeholdera, żeby nie dublować jednego zdjęcia.
const dummyGallery = Array.from({ length: 50 }, (_, i) => 'placeholder');

const App = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [lang, setLang] = useState('pl');
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    // Stany dla Galerii
    const [visiblePhotos, setVisiblePhotos] = useState(8); // Pokazuj 8 na start
    const [selectedPhoto, setSelectedPhoto] = useState(null); // Do Lightboxa

    const { scrollYProgress } = useScroll();
    const scaleX = useSpring(scrollYProgress, { stiffness: 100, damping: 30 });
    const opacityHero = useTransform(scrollYProgress, [0, 0.2], [1, 0]);

    const t = translations[lang];

    useEffect(() => {
        const handleScroll = () => setIsScrolled(window.scrollY > 50);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleLoadMore = () => {
        if (visiblePhotos >= dummyGallery.length) {
            setVisiblePhotos(8); // Zwiń galerię
        } else {
            setVisiblePhotos(prev => prev + 8); // Dodaj kolejne 8
        }
    };

    return (
        <div style={{ backgroundColor: 'var(--bg-dark)' }}>
            <style dangerouslySetInnerHTML={{ __html: globalStyles }} />
            <motion.div style={{ scaleX, position: 'fixed', top: 0, left: 0, right: 0, height: '3px', backgroundColor: 'var(--burgund)', zIndex: 3000, originX: 0 }} />

            {/* LIGHTBOX (MODAL) */}
            <AnimatePresence>
                {selectedPhoto && (
                    <motion.div
                        className="lightbox-overlay"
                        initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
                        onClick={() => setSelectedPhoto(null)}
                    >
                        <button className="close-btn" onClick={() => setSelectedPhoto(null)}>✕</button>
                        <motion.img
                            src={selectedPhoto}
                            alt="Full screen placeholder"
                            className="lightbox-img"
                            initial={{ scale: 0.8 }} animate={{ scale: 1 }} exit={{ scale: 0.8 }}
                            onClick={(e) => e.stopPropagation()}
                        />
                    </motion.div>
                )}
            </AnimatePresence>

            {/* NAWIGACJA */}
            <nav className="nav-container" style={{
                position: 'fixed', top: 0, width: '100%', zIndex: 2000,
                padding: isScrolled ? '15px 40px' : '30px 60px',
                backgroundColor: isScrolled || mobileMenuOpen ? 'rgba(0,0,0,0.98)' : 'transparent',
                borderBottom: isScrolled ? '1px solid var(--burgund)' : '1px solid transparent',
                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                transition: 'all 0.6s cubic-bezier(0.16, 1, 0.3, 1)',
                boxSizing: 'border-box'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                    <motion.div animate={{ rotate: 360 }} transition={{ duration: 20, repeat: Infinity, ease: "linear" }} style={{ width: '10px', height: '10px', backgroundColor: 'var(--burgund)' }} />
                    <span style={{ fontFamily: "'Cinzel', serif", fontWeight: 900, letterSpacing: '6px', fontSize: '1.2rem', color: 'var(--champagne)' }}>
                        FIRST <span style={{ color: 'var(--burgund)' }}>INDIAN</span> CLUB
                    </span>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '40px' }}>
                    <div className="desktop-nav">
                        <a href="#start" style={{ color: 'inherit', textDecoration: 'none' }}>{t.nav[0]}</a>
                        <a href="#oklubie" style={{ color: 'inherit', textDecoration: 'none' }}>{t.nav[1]}</a>
                        <a href="#historia" style={{ color: 'inherit', textDecoration: 'none' }}>{t.nav[2]}</a>
                    </div>

                    <div style={{ display: 'flex', gap: '5px' }}>
                        <button className={`lang-btn ${lang === 'pl' ? 'active' : ''}`} onClick={() => setLang('pl')}>PL</button>
                        <button className={`lang-btn ${lang === 'en' ? 'active' : ''}`} onClick={() => setLang('en')}>EN</button>
                    </div>

                    <div className="mobile-hamburger" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
                        <div />
                        <div />
                        <div />
                    </div>
                </div>

                <AnimatePresence>
                    {mobileMenuOpen && (
                        <motion.div initial={{ x: '100%' }} animate={{ x: 0 }} exit={{ x: '100%' }} style={{ position: 'fixed', top: 0, right: 0, bottom: 0, left: 0, background: 'var(--bg-dark)', zIndex: 1999, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '30px' }}>
                            {t.nav.map((item, i) => (
                                <a key={i} href={`#${item.toLowerCase().replace(' ', '')}`} onClick={() => setMobileMenuOpen(false)} style={{ color: 'var(--champagne)', textDecoration: 'none', fontSize: '1.5rem', letterSpacing: '4px' }}>{item}</a>
                            ))}
                            <button onClick={() => setMobileMenuOpen(false)} style={{ marginTop: '40px', background: 'none', border: '1px solid var(--burgund)', color: 'var(--champagne)', padding: '10px 20px' }}>ZAMKNIJ</button>
                        </motion.div>
                    )}
                </AnimatePresence>
            </nav>

            {/* HERO SECTION */}
            <section id="start" style={{ height: '100vh', display: 'flex', position: 'relative', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
                <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(circle at 50% 50%, #1a0000 0%, #000000 100%)', zIndex: 1 }} />
                <motion.div style={{ zIndex: 10, opacity: opacityHero }}>
                    <motion.img initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1.2 }} src={logoKlubu} alt="Logo" style={{ width: '95%', maxWidth: '650px', filter: 'drop-shadow(0 0 45px rgba(74,0,0,0.3))', marginBottom: '40px' }} />
                    <AnimatePresence mode="wait">
                        <motion.div key={lang} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }} transition={{ duration: 0.5 }}>
                            <h1 className="hero-title" style={{ fontFamily: "'Cinzel', serif", fontSize: 'clamp(2rem, 6vw, 5.5rem)', margin: 0, letterSpacing: '18px', fontWeight: 900, color: 'var(--champagne)' }}>
                                {t.heroTitle[0]} <span style={{ color: 'var(--burgund)' }}>•</span> {t.heroTitle[1]}
                            </h1>
                            <p className="hero-sub" style={{ letterSpacing: '12px', fontSize: '13px', opacity: 0.8, textTransform: 'uppercase', color: 'var(--champagne)', marginTop: '20px' }}>
                                {t.heroSub}
                            </p>
                        </motion.div>
                    </AnimatePresence>
                </motion.div>
            </section>

            {/* O KLUBIE */}
            <section id="oklubie" className="section-padding" style={{ padding: '120px 0 60px 0', borderTop: '1px solid rgba(229, 196, 139, 0.05)' }}>
                <div className="about-grid" style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 40px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '80px', alignItems: 'center' }}>
                    <motion.div initial={{ opacity: 0, x: -40 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
                        <h2 style={{ fontFamily: "'Cinzel', serif", fontSize: '3rem', color: 'var(--champagne)', marginBottom: '30px' }}>
                            <span style={{ color: 'var(--burgund)' }}>{t.aboutTitle[0]}</span> {t.aboutTitle[1]}
                        </h2>
                        <p style={{ fontSize: '1.1rem', lineHeight: '1.8', fontWeight: 200, color: 'var(--champagne)', opacity: 0.9 }}>
                            {t.aboutText}
                        </p>
                        <a href="#galeria" className="main-btn">{t.aboutBtn}</a>
                        <div style={{ marginTop: '30px', height: '1px', width: '60px', backgroundColor: 'var(--burgund)' }} />
                    </motion.div>

                    <motion.div whileHover={{ scale: 1.02 }} className="glass-card" style={{ height: '350px', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <img src={zdj1} style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.8 }} alt="Side" />
                    </motion.div>
                </div>
            </section>

            {/* GALERIA */}
            <section id="galeria" className="section-padding" style={{ padding: '0 40px 120px 40px', textAlign: 'center' }}>
                <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '15px' }}>
                        <AnimatePresence>
                            {dummyGallery.slice(0, visiblePhotos).map((_, i) => (
                                <motion.div
                                    key={i}
                                    initial={{ opacity: 0, scale: 0.9 }}
                                    animate={{ opacity: 1, scale: 1 }}
                                    exit={{ opacity: 0, scale: 0.9 }}
                                    transition={{ duration: 0.3 }}
                                    whileHover={{ scale: 1.03 }}
                                    style={{ height: '250px', border: '1px solid rgba(229, 196, 139, 0.1)', overflow: 'hidden', backgroundColor: '#050505', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                    onClick={() => setSelectedPhoto(logoKlubu)} // Pokazuje logo w lightboxie jako placeholder
                                >
                                    <img src={logoKlubu} style={{ width: '40%', opacity: 0.15, transition: '0.3s' }} alt={`Galeria Placeholder ${i}`} onMouseOver={e => e.currentTarget.style.opacity = 0.3} onMouseOut={e => e.currentTarget.style.opacity = 0.15} />
                                </motion.div>
                            ))}
                        </AnimatePresence>
                    </div>

                    {/* Przycisk Load More */}
                    <button onClick={handleLoadMore} className="main-btn" style={{ marginTop: '50px' }}>
                        {visiblePhotos >= dummyGallery.length ? t.showLess : t.loadMore}
                    </button>
                </div>
            </section>

            {/* HISTORIA */}
            <section id="historia" className="section-padding" style={{ padding: '120px 0', backgroundColor: 'var(--bg-light)' }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 40px' }}>
                    <h2 style={{ fontFamily: "'Cinzel', serif", fontSize: '2.5rem', color: 'var(--champagne)', textAlign: 'center', marginBottom: '60px' }}>
                        {t.historyTitle[0]} <span style={{ color: 'var(--burgund)' }}>{t.historyTitle[1]}</span>
                    </h2>
                    <div className="history-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '30px' }}>
                        {t.historyItems.map((item, i) => (
                            <motion.div key={i} className="glass-card" style={{ padding: '50px 30px', textAlign: 'center' }}>
                                <h3 style={{ fontSize: '3.5rem', color: 'var(--burgund)', margin: '0 0 10px 0', fontWeight: 900 }}>{item.y}</h3>
                                <h4 style={{ letterSpacing: '4px', color: 'var(--champagne)', marginBottom: '20px', textTransform: 'uppercase' }}>{item.t}</h4>
                                <p style={{ opacity: 0.7, fontSize: '0.95rem', lineHeight: '1.7', fontWeight: 300 }}>{item.d}</p>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            {/* FOOTER */}
            <footer style={{ padding: '80px 40px 60px 40px', textAlign: 'center', borderTop: '1px solid var(--burgund)' }}>
                <div style={{ display: 'flex', justifyContent: 'center', gap: '60px', marginBottom: '40px', flexWrap: 'wrap' }}>
                    <a href="https://www.facebook.com/profile.php?id=100093160692324" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--champagne)', textDecoration: 'none', fontSize: '11px', letterSpacing: '4px', fontWeight: 700 }}>FACEBOOK</a>
                </div>

                <p style={{ opacity: 0.2, fontSize: '10px', letterSpacing: '6px', color: 'var(--champagne)', margin: '0' }}>
                    © 2026 FIRST INDIAN CLUB POLAND | EST. 2015 | LUBLIN
                </p>

                {/* DYNAMICZNE AUTORSTWO */}
                <p style={{ opacity: 0.5, fontSize: '10px', letterSpacing: '2px', color: 'var(--champagne)', marginTop: '20px' }}>
                    {t.createdBy} <a href="https://brzuzy.pl" target="_blank" rel="noopener noreferrer" className="creator-link">PRZEMYSŁAW BRZUZY</a>
                </p>
            </footer>
        </div>
    );
};

export default App;
